<template>
    <div class="maincontent py-4" id="haut">
        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="content columns mx-0 py-3">
            <div class="page column is-6 is-offset-3" data-aos="zoom-in">
                <br><br>
                <NotFound />
            </div>
        </div>
        <div v-if="page">
            <h1 class="is-hidden">{{page.title | capitalize}}</h1>
            <div v-if="page.image && page.image.path">
                <div v-if="!page.pospic || page.pospic == 'left'" class="content columns mx-0 py-3">
                    <div class="page column is-4 is-offset-1" data-aos="zoom-in">
                        <figure class="image my-5">
                            <img :src="page.image.path" alt="illustration">
                        </figure>
                    </div>
                    <div class="page column is-6 px-3 mx-3" data-aos="zoom-in">
                        <h1 class="title is-2">{{page.title | capitalize}}</h1>
                        <span v-html="page.content"></span>
                    </div>
                </div>
                <div v-if="page.pospic == 'right'" class="content columns mx-0 py-3">
                    <div class="page column is-6 is-offset-1" data-aos="zoom-in">
                        <h1 class="title is-2">{{page.title | capitalize}}</h1>
                        <span v-html="page.content"></span>
                    </div>
                    <div class="page column is-4" data-aos="zoom-in">
                        <figure class="image my-5">
                            <img :src="page.image.path" alt="illustration">
                        </figure>
                    </div>
                </div>
                <div v-if="page.pospic == 'top'" class="onecol">
                    <div class="content">
                        <div class="topimage" data-aos="zoom-in">
                            <figure class="image">
                                <img :src="page.image.path" alt="illustration">
                            </figure>
                        </div>
                        <div class="bottomcontent my-6" data-aos="zoom-in">
                            <h1 class="title is-2">{{page.title | capitalize}}</h1>
                            <span v-html="page.content"></span>
                        </div>
                    </div>
                </div>
                <div v-if="page.pospic == 'bottom'" class="onecol">
                    <div class="content">
                        <div class="topcontent" data-aos="zoom-in">
                            <h1 class="title is-2">{{page.title | capitalize}}</h1>
                            <span v-html="page.content"></span>
                        </div>
                        <br><br>
                        <div class="bottomimage" data-aos="zoom-in">
                            <figure v-bind:class="[page.enlevecadrepic ? '' : 'image', 'my-5']">
                                <img :src="page.image.path" alt="illustration">
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="topcontent py-6" data-aos="zoom-in">
                    <h1 class="title is-2">{{page.title | capitalize}}</h1>
                    <span v-html="page.content"></span>
                </div>
            </div>
            <template v-if="page && images && images.length">
                <div class="has-background-darkx pt-5 pb-5 mb-3 px-1 has-text-centered">
                <silent-box :gallery="images" :preview-count="12"></silent-box>
                <span class="has-text-whitex is-italic"><small>cliquez sur une photo pour lancer le diaporama (touche &lt; ou &gt; pour changer de photo)</small></span>
                </div>
                <div v-if="!page.content2"><div class="my-6"></div></div>
            </template>

             <template v-if="page && page.content2">
                <div class="topcontent py-6" data-aos="zoom-in">
                    <span v-html="page.content2"></span>
                </div>
            </template>

        </div>
    </div>
</template>
<script>
const axios = require('axios');
import NotFound from './NotFound.vue';

export default {
    data: function() {
        return {
            maintitle: 'Page',
            loading: true,
            page: null,
            error: null,
            images: [],
        }
    },
    components: {
        NotFound,
    },
    name: 'Page',
    props: {
        msg: String
    },
    created() {
        this.fetchData()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    updated: function() {
        const links = this.$el.querySelectorAll("a[href^='collection://']")
        links.forEach((link) => {
            link.href = link.href.replace('collection://', "#/");
        });
        const imgs = this.$el.querySelectorAll("img[src^='/storage']")
        imgs.forEach((img) => {
            var curloc = window.location.origin
            var newsrc = img.src.replace(curloc, '')
            newsrc = this.$api_url_base + newsrc
            img.src = newsrc
        });

        this.maintitle = this.page ? this.page.title : this.maintitle;
    },
    methods: {
        fetchData() {
            this.error = this.page = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_pages

            axios({
                    method: 'post',
                    url: fetchurl,
                    headers: { 'Content-Type': 'application/json' },
                    data: JSON.stringify({
                        filter: { slug: 'page/' + vm.$route.params.id },
                        //fields: {fieldA:1},
                        limit: 1,
                        sort: { _created: -1 },
                        populate: 1, // resolve linked collection items
                        lang: 'fr' // return normalized language fields (fieldA_de => fieldA)
                    })
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.page = response.data.entries[0]

                        var gallery = vm.page.diaporama ?? null
                        if (gallery) {
                            var n_photos = gallery.length
                            gallery.forEach((item, index) => {
                                var photo = {
                                    src: item.path,
                                    description: item.meta.title + " [" + (index+1) + "/" + n_photos + "]",
                                    thumbnailWidth: '220px',
                                    srcSet: vm.$api_url_base + item.path,
                                }
                                vm.images.push(photo)
                            })
                        }

                        //console.log(vm.images)

                        vm.error = null
                    } else {
                        vm.page = null
                        vm.error = 'page introuvable'
                    }
                })
                .catch(function() {
                    vm.loading = false
                    vm.error = 'page introuvable'
                })
        },
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
    min-height: 550px;
    margin-bottom: 40px;
    margin-top: 60px;
    padding-left: 35px;
    padding-right: 35px;
}

.image img {
    max-height: 300px;
    width: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.loading {
    min-height: 600px;
}

.onecol {
    padding-bottom: 80px;
    padding-top: 60px;
}

.topimage,
.bottomimage {
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 0px;
}

.bottomcontent,
.topcontent {
    max-width: 900px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 0px;
}

ul {
    list-style: square inside !important;
}

@media only screen and (max-width: 415px) {
    .page {
        min-height: 150px;
        margin-bottom: 20px;
        margin-top: 20px;
        padding: 0px;
    }

    .maincontent {
        padding-left: 10px;
        padding-right: 10px;
    }

    .image {
        margin: 0px;
        margin-bottom: 40px;
    }
}
</style>